export interface ICountData {
    completedCounts: number;
    totalCounts: number;
}

export interface IKeyedInStatus {
    id: string;
    name: string;
}

export interface ISampleKeyedInDetails {
    count: ICountData;
    id: string;
    status: IKeyedInStatus;
    name: string;
    unit: string;
}

export class SampleKeyedInDetails implements ISampleKeyedInDetails {
    count: ICountData;
    id: string;
    status: IKeyedInStatus;
    name: string;
    unit: string;

    constructor(count: ICountData,
        id: string,
        status: IKeyedInStatus,
        name: string, unit: string) {

        this.count = count;
        this.id = id;
        this.status = status;
        this.name = name;
        this.unit = unit;
    }
}

const defaultSampleKeyedInDetails = new SampleKeyedInDetails({ totalCounts: 0, completedCounts: 0 }, "", { id: "", name: "" }, "", "");
export { defaultSampleKeyedInDetails };